











import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "PayeeInfoButton",
  components: { BaseButton },
  props: {
    isLastStep: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean },
  },
});
